/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Slim_Wolf_RaceInputs */

const en_kind_slim_wolf_race = /** @type {(inputs: Kind_Slim_Wolf_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search attributes...`)
};

const de_kind_slim_wolf_race = /** @type {(inputs: Kind_Slim_Wolf_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkmale suchen...`)
};

/**
* | output |
* | --- |
* | "Search attributes..." |
*
* @param {Kind_Slim_Wolf_RaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const kind_slim_wolf_race = /** @type {((inputs?: Kind_Slim_Wolf_RaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Slim_Wolf_RaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kind_slim_wolf_race(inputs)
	return de_kind_slim_wolf_race(inputs)
});